import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { buildLoginRedirectTo, destinationForAuthRedirect, rememberPostLoginPath } from '../utils/authRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    const next = destinationForAuthRedirect(location.pathname, location.search || '');
    rememberPostLoginPath(next);
    return <Navigate to={buildLoginRedirectTo(next)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
